import React, { useCallback, useMemo } from 'react';
import DownloadIcon from 'icons/Download.icon';
import EyeIcon from 'icons/Eye.icon';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

export default function useInsights(
  buySidePreviewMember: DataRoomMember,
  isBuySidePreviewMemberViewer: boolean,
  numberOfViews: number,
  numberOfDownloads: number,
  buyerNumberOfViews: number,
  buyerNumberOfDownloads: number,
) {
  const generateMenuSpanContent = useCallback(
    (count: number, icon: React.ReactNode) => (
      <span className="dr-generated-span">
        {count || 0}
        {icon}
      </span>
    ),
    [],
  );

  const downloadInsight = useMemo(
    () =>
      !buySidePreviewMember || !isBuySidePreviewMemberViewer ? (
        generateMenuSpanContent(
          buySidePreviewMember ? buyerNumberOfDownloads : numberOfDownloads,
          <DownloadIcon />,
        )
      ) : (
        <span />
      ),
    [
      buySidePreviewMember,
      isBuySidePreviewMemberViewer,
      buyerNumberOfDownloads,
      numberOfDownloads,
      generateMenuSpanContent,
    ],
  );

  const viewInsight = useMemo(
    () =>
      generateMenuSpanContent(
        buySidePreviewMember ? buyerNumberOfViews : numberOfViews,
        <EyeIcon />,
      ),
    [
      buySidePreviewMember,
      buyerNumberOfViews,
      numberOfViews,
      generateMenuSpanContent,
    ],
  );

  return { downloadInsight, viewInsight };
}
